import { z } from 'zod';

export interface UserEncounterShortInfo {
  name: string;
  avatar: string;
}
export interface FloorPlanShort {
  id: number;
  title: string;
  slug: string;
}

export interface PestOrTracesShort {
  id: number;
  name_US: string;
  name_UA: string;
}

export interface Vulnerability {
  id: number;
  category: string;
  create_date: string;
  last_date: string;
  fixed: boolean;
  fix_date: string | null;
}

export interface Encounter {
  id: number;
  status: string;
  floor_plan: FloorPlanShort | null;
  discovery_datetime: string;
  place: string;
  pest: PestOrTracesShort | null;
  amount: number;
  pest_traces: PestOrTracesShort | null;
  witness: UserEncounterShortInfo;
  responsible_person: UserEncounterShortInfo;
  fix_datetime: string | null;
  fix_comment: string | null;
  connected_vuls: Vulnerability[] | null;
  creation_comment: string | null;
  fix_commentL: string | null;
  after_photos: string[] | null;
  before_photos: string[] | null;
}

export interface UserShortInfo {
  name: string;
  image: string;
  id: number;
  role: string;
  is_client: boolean;
}

export interface Employee {
  id: number;
  first_name: string;
  last_name: string;
  avatar: string;
  email: string;
  role: string;
}

export interface Pest {
  id: number;
  name: string;
}

export interface FloorPlan {
  id: number;
  title: string;
  slug: string;
  scale: number;
  area: string;
  floor_plan: string;
  add_date: string;
}

export interface ApiResponse {
  request_user_short_info: UserShortInfo;
  object_responsible_person: UserShortInfo;
  client_employees: Employee[];
  service_employees: Employee[];
  pest_list: Pest[];
  pest_traces_list: Pest[];
  floor_plan_list: FloorPlan[];
}

export const encUpdateAfterBlitzSchema = z.object({
  creation_comment: z.string({ required_error: 'Creation comment is required' }).min(1, {
    message: 'Creation comment is required',
  }),
  photos: z.array(z.instanceof(File)).optional().nullable(),
  responsible_person: z.number({ required_error: 'Responsible person is required' }).min(1, {
    message: 'Responsible person is required',
  }),
});

export type EncUpdateAfterBlitzFormValues = z.infer<typeof encUpdateAfterBlitzSchema>;

export const completeEncounterSchema = z.object({
  fix_comment: z.string({ required_error: 'Fix comment is required' }).min(1, {
    message: 'Fix comment is required',
  }),
  fix_datetime: z.string({ required_error: 'Fix datetime is required' }).min(1, {
    message: 'Fix datetime is required',
  }),
  connected_vuls: z.array(z.number()).optional(),
  photos: z.array(z.instanceof(File)).optional().nullable(),
});

export type CompleteEncounterFormValues = z.infer<typeof completeEncounterSchema>;
